import React from "react";

import { cilArrowTop, cilArrowBottom } from "@coreui/icons";
import CIcon from "@coreui/icons-react";

const TableColumnSortIcon = ({ sortConfig, dataKey }) => {
  const item = sortConfig.find((item) => item.key === dataKey);
  return item ? (
    <CIcon
      icon={item.direction === "asc" ? cilArrowTop : cilArrowBottom}
      size="sm"
      className="ms-1"
    />
  ) : null;
};

export default TableColumnSortIcon;
